import { render, staticRenderFns } from "./WhiteHeader.vue?vue&type=template&id=2c9c3228&scoped=true&"
import script from "./WhiteHeader.vue?vue&type=script&lang=js&"
export * from "./WhiteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c3228",
  null
  
)

export default component.exports